<div class="container mt-4">
  <div class="form-group">
    <label>Short Code</label>
    <input class="form-control" [(ngModel)]="OGshortcode" [readonly]="isEditMode" />
  </div>
  <div class="form-group">
    <label>Name</label>
    <input class="form-control" [(ngModel)]="OGName" />
  </div>
  <div class="form-group">
    <label>Remarks</label>
    <input class="form-control" [(ngModel)]="OGRemarks" />
  </div>
  <div class="form-check" *ngIf="!isEditMode">
    <input class="form-check-input" type="checkbox" [(ngModel)]="useExistingLines" />
    <label class="form-check-label">Use lines from existing object group</label>
  </div>
  <div class="form-group" *ngIf="useExistingLines && !isEditMode">
    <label>Select object group</label>
    <select class="form-control" [(ngModel)]="selectedObjectGroup">
      <option value="">-- Select object group --</option>
      <option *ngFor="let objectGroup of objectGroups" [value]="objectGroup.objGroupShortcode">
        {{ objectGroup.objGroupShortcode }} — {{ objectGroup.objGroupName }}
      </option>
    </select>
  </div>
  <button class="btn btn-success" (click)="saveObjectGroup()">Save</button>
</div>

